import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { AuthInterceptorService } from 'app/app.module';

const ignoredWebpackMessageTypes = [
  'webpackOk',
  'webpackClose',
  'webpackWarnings',
  'webpackInvalid',
];

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  baseAPIUrl: any;
  ReportsAPIUrl: any;
  baseAPIUrlHub: any;
  config: any;

  private readonly isConfigured$ = new ReplaySubject<void>(1);

  constructor(
    private httpClient: HttpClient,
    private authInterceptorService: AuthInterceptorService,
    private authService: AuthService,
    private injector: Injector
  ) {}

  public loadConfig() {
    var result = this.httpClient
      .get('/assets/CcgAppConfig.json')
      .toPromise()
      .then((config: any) => {
        this.config = config;
        this.baseAPIUrl = this.config.baseAPIUrl;
        this.ReportsAPIUrl = this.config.ReportsAPIUrl;

        if (this.config.portalEnabled) {
          this.setupPortalListeners();
          window.parent.postMessage({ type: 'requestUserSession' }, '*');
          window.parent.postMessage(
            {
              type: 'setMenu',
              payload: {
                menu: config.menu,
              },
            },
            '*'
          );

          return this.isConfigured$.toPromise();
        }
      })
      .catch((err: any) => {
        // this.baseAPIUrl="http://localhost:4435/";
      });

    return result;
  }

  public setupPortalListeners() {
    // Adding Router inside the constructor creates a circular dependency.
    // Injecting it here solves the issue and still works.
    const router = this.injector.get(Router);

    window.addEventListener('message', (event: MessageEvent) => {
      if (ignoredWebpackMessageTypes.includes(event.data.type)) {
        return;
      }

      // Optional chain expression (event?.data) do not work.
      // So we check it the long way.
      if (!event) {
        console.warn('No message event was given.');
        return;
      }

      if (event.data.type === 'userSession') {
        if (
          !event.data.payload ||
          !event.data.payload.backend ||
          !event.data.payload.backend.token
        ) {
          throw new Error(
            `Got userSession event without event.data.payload.backend.token.`
          );
        }

        this.authInterceptorService.setToken(event.data.payload.backend.token);
        this.authService.setToken(event.data.payload.backend.token);

        const dataPart = event.data.payload.backend.token.split('.')[1];
        const decodedString = atob(dataPart);
        const decoded = JSON.parse(decodedString);
        const userId = decoded['SageEvolutionAgentId'];
        if (userId) {
          sessionStorage.setItem('UserID', userId);
        }

        this.isConfigured$.next();
        this.isConfigured$.complete();
        return;
      }

      if (event.data.type === 'nav') {
        let path = event.data.payload.url;
        path = path.replace(/^#!\//, '');
        // let url = `${window.location.protocol}//${window.location.host}/${path}`;
        // window.location.replace(url);
        router.navigateByUrl(path);
        return;
      }

      console.log('Unknown message type: ', event);
    });
  }
}
